import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      app: {
         accountConfigurationInfo: {
            close: 'Zamknij',
            completeConfigurationSoThatDoctorsCanConductVisits:
               'Dokończ konfigurację, aby lekarze mogli przeprowadzać wizyty',
            completeConfigurationToMakeMedicalVisits: 'Dokończ konfigurację, aby przeprowadzać wizyty lekarskie',
            completeConfigurationToMakeVisits: 'Dokończ konfigurację, aby przeprowadzać wizyty',
            configure: 'Konfiguruj',
            doYouNeedHelp: 'Potrzebujesz pomocy? Skorzystaj z <link /> krok po kroku',
            healthcareOrganizationData: 'Dane podmiotu',
            healthcarePracticeData: 'Dane praktyki',
            instruction: 'instrukcji konfiguracji',
            lackOfFullHealthcareProviderConfigurationOnPartAdministrator:
               'Brakuje pełnej konfiguracji po stronie Administratora podmiotu - skontaktuj się z nim, aby móc przeprowadzać wizyty.',
            p1Certificates: 'Certyfikaty P1',
            personalCertificate: 'Certyfikat osobisty',
            peselAndProfession: 'Numer PESEL i zawód',
            pwzAndSpecialization: 'Numer PWZ i specjalizacja',
            ready: 'Gotowe',
         },
         confidentialityNotifications: {
            pendingRequestsTooltip: 'Wnioski o dostęp do danych poufnych do rozpatrzenia.',
         },
         experimental: 'Tryb eksperymentalny',
         faultHandlerMap: {
            PatientExternalIdentifierRequiredFault:
               'Nie można wystawić tego dokumentu dla typu identyfikatora "Numer kartoteki".',
         },
         identifier: 'ID {{id}}',
         mainMenu: {
            calendar: 'Kalendarz',
            groupSessions: 'Terapie grupowe',
            helpCenter: 'Centrum pomocy',
            moduleIndicators: {
               neurological: 'neurologia',
               psychiatric: 'psychiatria',
            },
            patients: 'Pacjenci',
            paymentsAndInvoices: 'Płatności i faktury',
            pharmindex: 'Pharmindex',
            prescriptionVisits: 'Wizyty receptowe',
            statistics: 'Statystyki',
            visits: 'Wizyty',
         },
         mfaRequired: {
            activeMfaNow: 'Aktywuj MFA teraz',
            day: 'dzień',
            days: 'dni',
            doYouNeedHelpConfiguringMfa: 'Potrzebujesz wsparcia przy aktywacji MFA?',
            email: 'E-mail: <link />',
            goToHelpCenter: 'Przejdź do centrum pomocy',
            googleAuthenticator: 'Google Authenticator',
            helpCenter: 'Centrum pomocy: <link />',
            hotline: 'Infolinia: <link />',
            improvingAccountSecurity: 'Zwiększamy bezpieczeństwo Twojego konta',
            mfaIsAboutUsingApp:
               'Weryfikacja dwuetapowa polega na potwierdzeniu logowania dodatkowym kodem generowanym w aplikacji uwierzytelniającej, np.:',
            mfaWillBeRequiredSoon:
               'Aby zwiększyć bezpieczeństwo danych w systemie eGabinet, weryfikacja dwuetapowa (MFA) będzie wkrótce wymagana dla wszystkich użytkowników.',
            msAuthenticator: 'Microsoft Authenticator',
            remindLater: 'Przypomnij później',
            youHaveXDaysLeft:
               'Masz jeszcze <strong>{{daysCount}} {{daysCountSuffix}}</strong>, aby włączyć MFA dla swojego konta.',
            youWontBeAbleToAccessAccountAfterDate:
               'Po tym czasie logowanie do systemu bez aktywnej weryfikacji dwuetapowej nie będzie możliwe.',
         },
         mobileVersionAvailableModal: {
            actions: {
               redirectToMobile: 'Kontynuuj w wersji mobilnej',
               stayOnDesktop: 'Kontynuuj w wersji na komputer',
            },
            content: 'Pracuj wygodniej na mobilnej wersji drEryk eGabinet.',
            liteVersionInformation:
               'Mobilna wersja zawiera tylko najważniejsze funkcje. Pełny zakres możliwości jest dostępny w wersji na komputer.',
            title: 'Wygodniejsza wersja mobilna',
         },
         payInvoices:
            'Pracujesz w trybie tylko do odczytu. Ureguluj zaległe faktury, by przywrócić pełne działanie programu.',
         paymentsAndInvoices: {
            heading: 'Płatności i faktury',
         },
         settings: {
            tabs: {
               extendedDosageTemplates: 'Szablony dawkowania rozszerzonego',
               magistralDrugTemplates: 'Szablony leków recepturowych',
               prescriptionVisitTemplates: 'Szablon wizyt receptowych',
               visitTemplates: 'Szablony wizyt',
            },
            templates: 'Szablony',
         },
         subscriptionEnding: {
            anotherSubscriptionYearStart:
               'W dniu <bold>{{date}}</bold> rozpoczyna się kolejny rok subskrypcji oprogramowania drEryk eGabinet.',
            close: 'Zamknij',
            contactUs: 'Skontaktuj się z nami',
            dearUser: 'Drogi Użytkowniku,',
            invoiceForNextBillingPeriodWillBeIssuedInKsef:
               'Faktura za kolejny okres rozliczeniowy zostanie wystawiona <br>w <bold>Krajowym Systemie e-Faktur</bold>.',
            thankYou: 'Dziękujemy!',
            thankYouForBeingWithUs: 'Dziękujemy, że jesteś z nami!',
         },
         userDropdown: {
            myAccount: 'Moje konto',
            myHealthCareInstitution: 'Moja praktyka', // Current value due to MVP target customers, however target value is "Moja Placówka"
            schedule: 'Harmonogram',
            systemActivity: 'Aktywność systemowa',
            templates: 'Szablony',
         },
         whatsNew: 'Co nowego w drEryk eGabinet?',
      },
   },
};

export const appTranslationKeys = createScopedTranslationKeys(translations.pl, 'app');
export const accountConfigurationInfoTranslationKeys = appTranslationKeys.accountConfigurationInfo;
export const userDropdownTranslationKeys = appTranslationKeys.userDropdown;
export const confidentialityNotificationsTranslationKeys = appTranslationKeys.confidentialityNotifications;
export const settingsTranslationKeys = appTranslationKeys.settings;
export const subscriptionEndingTranslationKeys = appTranslationKeys.subscriptionEnding;
export const paymentsAndInvoicesTranslationKeys = appTranslationKeys.paymentsAndInvoices;
export const mobileVersionAvailableModalTranslationKeys = appTranslationKeys.mobileVersionAvailableModal;
export const faultHandlerMapTranslationKeys = appTranslationKeys.faultHandlerMap;
export const mfaRequiredTranslationKeys = appTranslationKeys.mfaRequired;
